/** form steps reducers **/

// step one
export {default as FormStepOneReducer} from "./form/steps/one";
// step two
export {default as FormStepTwoReducer} from "./form/steps/two";
// step three
export {default as FormStepThreeReducer} from "./form/steps/three";

/** -- end form steps reducers -- **/
